'use client';

import { ErrorPageWithoutRedirect } from '@haaretz/s-error-pages/default';
export default ErrorPageWithoutRedirect;
